import _classCallCheck from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as Vec2Func from './functions/Vec2Func.js';
export var Vec2 = /*#__PURE__*/function (_Array) {
  _inherits(Vec2, _Array);

  var _super = _createSuper(Vec2);

  function Vec2() {
    var _this;

    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;

    _classCallCheck(this, Vec2);

    _this = _super.call(this, x, y);
    return _possibleConstructorReturn(_this, _assertThisInitialized(_this));
  }

  _createClass(Vec2, [{
    key: "x",
    get: function get() {
      return this[0];
    },
    set: function set(v) {
      this[0] = v;
    }
  }, {
    key: "y",
    get: function get() {
      return this[1];
    },
    set: function set(v) {
      this[1] = v;
    }
  }, {
    key: "set",
    value: function set(x) {
      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
      if (x.length) return this.copy(x);
      Vec2Func.set(this, x, y);
      return this;
    }
  }, {
    key: "copy",
    value: function copy(v) {
      Vec2Func.copy(this, v);
      return this;
    }
  }, {
    key: "add",
    value: function add(va, vb) {
      if (vb) Vec2Func.add(this, va, vb);else Vec2Func.add(this, this, va);
      return this;
    }
  }, {
    key: "sub",
    value: function sub(va, vb) {
      if (vb) Vec2Func.subtract(this, va, vb);else Vec2Func.subtract(this, this, va);
      return this;
    }
  }, {
    key: "multiply",
    value: function multiply(v) {
      if (v.length) Vec2Func.multiply(this, this, v);else Vec2Func.scale(this, this, v);
      return this;
    }
  }, {
    key: "divide",
    value: function divide(v) {
      if (v.length) Vec2Func.divide(this, this, v);else Vec2Func.scale(this, this, 1 / v);
      return this;
    }
  }, {
    key: "inverse",
    value: function inverse() {
      var v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this;
      Vec2Func.inverse(this, v);
      return this;
    } // Can't use 'length' as Array.prototype uses it

  }, {
    key: "len",
    value: function len() {
      return Vec2Func.length(this);
    }
  }, {
    key: "distance",
    value: function distance(v) {
      if (v) return Vec2Func.distance(this, v);else return Vec2Func.length(this);
    }
  }, {
    key: "squaredLen",
    value: function squaredLen() {
      return this.squaredDistance();
    }
  }, {
    key: "squaredDistance",
    value: function squaredDistance(v) {
      if (v) return Vec2Func.squaredDistance(this, v);else return Vec2Func.squaredLength(this);
    }
  }, {
    key: "negate",
    value: function negate() {
      var v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this;
      Vec2Func.negate(this, v);
      return this;
    }
  }, {
    key: "cross",
    value: function cross(va, vb) {
      return Vec2Func.cross(va, vb);
    }
  }, {
    key: "scale",
    value: function scale(v) {
      Vec2Func.scale(this, this, v);
      return this;
    }
  }, {
    key: "normalize",
    value: function normalize() {
      Vec2Func.normalize(this, this);
      return this;
    }
  }, {
    key: "dot",
    value: function dot(v) {
      return Vec2Func.dot(this, v);
    }
  }, {
    key: "equals",
    value: function equals(v) {
      return Vec2Func.exactEquals(this, v);
    }
  }, {
    key: "applyMatrix3",
    value: function applyMatrix3(mat3) {
      Vec2Func.transformMat3(this, this, mat3);
      return this;
    }
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(mat4) {
      Vec2Func.transformMat4(this, this, mat4);
      return this;
    }
  }, {
    key: "lerp",
    value: function lerp(v, a) {
      Vec2Func.lerp(this, this, v, a);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new Vec2(this[0], this[1]);
    }
  }, {
    key: "fromArray",
    value: function fromArray(a) {
      var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      this[0] = a[o];
      this[1] = a[o + 1];
      return this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      a[o] = this[0];
      a[o + 1] = this[1];
      return a;
    }
  }]);

  return Vec2;
}( /*#__PURE__*/_wrapNativeSuper(Array));